'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { usePathname } from 'next/navigation'
import React, { useState } from 'react'

import type { Footer as FooterType, Topbar } from '@/payload-types'

import type { ExperienceStats } from '@/components/frontend/RedStatisticsBand'
import { Footer, Header } from '@/components/shared/layout/index'

type LayoutShellProps = {
  topbar: Topbar | null
  footer: FooterType | null
  logoUrl: string | null
  experienceStats?: ExperienceStats | null
  children: React.ReactNode
}

export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
  const [client] = useState(() => new QueryClient())

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}

export function LayoutShell({
  topbar,
  footer,
  logoUrl,
  experienceStats,
  children,
}: LayoutShellProps) {
  const pathname = usePathname() ?? ''
  const isAuthPage = pathname === '/login' || pathname.startsWith('/login/')
  const isDashboard = pathname === '/dashboard' || pathname.startsWith('/dashboard/')
  const isHome = pathname === '/'

  if (isDashboard) {
    return <main className="h-[100dvh] min-h-0 overflow-hidden bg-[#F5F5F5]">{children}</main>
  }

  return (
    <ReactQueryProvider>
      {!isAuthPage && <Header topbar={topbar} />}
      <main>{children}</main>
      {!isAuthPage && (
        <Footer
          footer={footer}
          logoUrl={logoUrl}
          experienceStats={experienceStats}
          showStatisticsBand={!isHome}
        />
      )}
    </ReactQueryProvider>
  )
}
